const footer = () => {
  $(() => {
    if ($(window).width() < 990) {
      $("footer .titolo-widget-sidebar").add("click", function () {
        if ($(this).find(".toggler").length) $(this).nextAll("div").slideToggle();
      });
      $("footer .toggler").each(function () {
        $(this).parent(".titolo-widget-sidebar").nextAll().hide();
      });
    }

    const modalLinks = document.querySelectorAll('a[href="#contactModal"]');
    if (modalLinks.length > 0) {
      modalLinks.forEach((modalLink) => {
        modalLink.setAttribute("data-bs-toggle", "modal");
        modalLink.setAttribute("data-bs-target", "#contactModal");
        // modalLink.addEventListener("click", (e) => {
        //   e.preventDefault;
        // });
      });
    }
  });
};

export default footer;
